import React, { lazy } from 'react';
import { Switch, Route } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const Galleries = lazy(() => import('../../container/galleries'));

const GalleryRoutes = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route path={`${path}/galleries`} component={Galleries}/>
        </Switch>
    );
};

export default GalleryRoutes;